import Skeleton from "@mui/material/Skeleton";
import "./Board.css";
import { memo } from "react";
import useSessionStorage from "@mirage/hooks/useSessionStorage";

interface BoardProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    children: React.ReactNode | React.ReactNode[];
    headerText?: string | React.ReactNode;
    loadingHeaderText?: boolean;
    size: "small" | "big";
}

const Board = memo((props: BoardProps): JSX.Element => {
    const { headerText, size, loadingHeaderText, className, ...other } = props;
    const customClass = className || "";
    const [sessionStorage] = useSessionStorage("publicportal");
    const gradientLeftColor = sessionStorage?.clientSettings?.GRADIENT_LEFT_COLOR || "#0357a6";
    const gradientRightColor = sessionStorage?.clientSettings?.GRADIENT_RIGHT_COLOR || "#188484";
    const background = `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(89.92deg, ${gradientLeftColor} 0.08%, ${gradientRightColor} 86.41%, ${gradientRightColor} 99.93%)`;
    const boardClass = `board ${size}-board ${customClass}`.trim();
    const boardHeaderBackground = size === "small" ? background : undefined;

    function getHeaderText() {
        if (loadingHeaderText) {
            return <Skeleton variant={"rectangular"} width={"250px"} sx={{ margin: "0 auto" }} />;
        } else if (headerText) {
            return `${headerText}`;
        }
    }

    return (
        <main id="main-board" className={boardClass} {...other}>
            {headerText || loadingHeaderText ? (
                <header className={size === "big" ? "board-header" : "small-board-header"} style={{ background: boardHeaderBackground }}>
                    <h1>{getHeaderText()}</h1>
                </header>
            ) : (
                ""
            )}
            {props.children}
        </main>
    );
});

export default Board;
export type { BoardProps };
